module.exports = __webpack_public_path__ + "static/media/taiwan.e74a6153.jpg";